







import { Vue, Watch } from "vue-property-decorator";
import { Mutation } from "vuex-class";
import Component from "vue-class-component";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { RouterPathName } from "@/enums/router-path-name.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class ComplaintFormView extends Vue {
  @Mutation("app/setTitlePrefix") setTitlePrefix!: (newPrefix: string) => void;
  @Watch("$route", { immediate: true }) private routeChanged(): void {
    this.setTranslatedTitlePrefix();
  }
  @Watch("$i18n.locale") private localeUpdated(): void {
    this.setTranslatedTitlePrefix();
  }

  title = "";
  i18nMessageKeyEnum = I18nMessageKey;

  private setTranslatedTitlePrefix(): void {
    const routeName = this.$route.name as RouterPathName;
    let title: string;
    if (routeName === RouterPathName.FalconComplaintFirstStepForm) {
      title = this.$t(
        this.i18nMessageKeyEnum.ComplaintsModuleTitleDetailsText
      ) as string;
    } else if (routeName === RouterPathName.FalconComplaintSecondStepForm) {
      title = this.$t(
        this.i18nMessageKeyEnum.ComplaintsModuleTitleVehicleDetailsText
      ) as string;
    } else if (routeName === RouterPathName.FalconComplaintThirdStepForm) {
      title = this.$t(
        this.i18nMessageKeyEnum.ComplaintsModuleTitleFaultDescriptionText
      ) as string;
    } else if (routeName === RouterPathName.FalconComplaintSummary) {
      title = this.$t(
        this.i18nMessageKeyEnum.ComplaintsModuleTitleSummaryText
      ) as string;
    } else {
      title = this.$t(
        this.i18nMessageKeyEnum.ComplaintsModuleTitleFormViewText
      ) as string;
    }
    title = capitalizeFilter.capitalize(title);
    this.title = title;
    this.setTitlePrefix(title);
  }
}
